import { render } from "./SubCategoryItem.vue?vue&type=template&id=ac78c39c&scoped=true"
import script from "./SubCategoryItem.vue?vue&type=script&lang=js"
export * from "./SubCategoryItem.vue?vue&type=script&lang=js"

import "./SubCategoryItem.vue?vue&type=style&index=0&id=ac78c39c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac78c39c"]])

export default __exports__